import { getWSIProjectionSnapshot, wsiProjectionAdapter, } from './wsiProjectionAdapter.js';
export { DefaultWSIDataProvider } from './DefaultWSIDataProvider.js';
export { createDefaultWSIRenderPaths, createWSIRenderPathResolver, } from './WSIRenderPathResolver.js';
export const wsiProjection = {
    adapter: wsiProjectionAdapter,
    getSnapshot: getWSIProjectionSnapshot,
};
export { default } from './WSIViewport.js';
